import { REACTIONS } from '../constants';

export function getTotalReactions(reactionCounts = {}) {
  return REACTIONS.reduce((sum, r) => sum + (reactionCounts[r.key] ?? 0), 0);
}

export function formatCount(n) {
  if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  return String(n);
}

export function sortByTrending(entries) {
  return [...entries].sort((a, b) => getTotalReactions(b.reactionCounts) - getTotalReactions(a.reactionCounts));
}

export function sortByNewest(entries) {
  return [...entries].sort((a, b) => b.createdAt - a.createdAt);
}

export function formatRelativeTime(timestamp) {
  const diffMs = Date.now() - timestamp;
  const diffDay = Math.round(diffMs / (24 * 60 * 60 * 1000));
  if (diffDay < 1) return 'today';
  if (diffDay === 1) return 'yesterday';
  if (diffDay < 30) return `${diffDay}d ago`;
  return new Date(timestamp).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
